var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BCol, BFormGroup, BFormInput, BRow } from "bootstrap-vue";
import Vue, { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { createBroadcast, fetchBroadcast, updateBroadcast } from "@/api/notifications.broadcast";
import { Toast } from "@/composables/toast";
import { errorMessageAsString } from "@/utils/simple-error";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
import FormElement from "@/components/Form/FormElement.vue";
import GDateTime from "@/components/GDateTime.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import BroadcastContainer from "@/components/Notifications/Broadcasts/BroadcastContainer.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastForm',
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const title = computed(() => {
            if (props.id) {
                return "Edit Broadcast";
            }
            else {
                return "New Broadcast";
            }
        });
        const loading = ref(false);
        const broadcastData = ref({
            source: "admin",
            variant: "info",
            content: {
                subject: "",
                message: "",
            },
            expiration_time: new Date(Date.now() + 6 * 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
            publication_time: new Date().toISOString().slice(0, 16),
        });
        const broadcastPublished = ref(false);
        const requiredFieldsFilled = computed(() => {
            return broadcastData.value.content.subject !== "" && broadcastData.value.content.message !== "";
        });
        const publicationDate = computed({
            get: () => {
                return new Date(`${broadcastData.value.publication_time}Z`);
            },
            set: (value) => {
                broadcastData.value.publication_time = value.toISOString().slice(0, 16);
            },
        });
        const expirationDate = computed({
            get: () => {
                return new Date(`${broadcastData.value.expiration_time}Z`);
            },
            set: (value) => {
                broadcastData.value.expiration_time = value.toISOString().slice(0, 16);
            },
        });
        function convertUTCtoLocal(utcTimeString) {
            const date = new Date(utcTimeString);
            return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
        }
        function addActionLink() {
            var _a;
            if (!broadcastData.value.content.action_links) {
                Vue.set(broadcastData.value.content, "action_links", []);
            }
            (_a = broadcastData.value.content.action_links) === null || _a === void 0 ? void 0 : _a.push({
                action_name: "",
                link: "",
            });
        }
        function createOrUpdateBroadcast() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (props.id) {
                        yield updateBroadcast(props.id, broadcastData.value);
                        Toast.success("Broadcast updated");
                    }
                    else {
                        yield createBroadcast(broadcastData.value);
                        Toast.success("Broadcast created");
                    }
                }
                catch (error) {
                    Toast.error(errorMessageAsString(error));
                }
                finally {
                    router.push("/admin/notifications");
                }
            });
        }
        function loadBroadcastData() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const loadedBroadcast = yield fetchBroadcast(props.id);
                    broadcastData.value.publication_time = convertUTCtoLocal(loadedBroadcast.publication_time);
                    if (loadedBroadcast.expiration_time) {
                        broadcastData.value.expiration_time = convertUTCtoLocal(loadedBroadcast.expiration_time);
                    }
                    broadcastData.value = loadedBroadcast;
                    if (broadcastData.value.publication_time) {
                        broadcastPublished.value = new Date(broadcastData.value.publication_time) < new Date();
                    }
                }
                catch (error) {
                    Toast.error(errorMessageAsString(error));
                }
                loading.value = false;
            });
        }
        if (props.id) {
            loadBroadcastData();
        }
        return { __sfc: true, props, router, title, loading, broadcastData, broadcastPublished, requiredFieldsFilled, publicationDate, expirationDate, convertUTCtoLocal, addActionLink, createOrUpdateBroadcast, loadBroadcastData, FontAwesomeIcon, BAlert, BButton, BCol, BFormGroup, BFormInput, BRow, AsyncButton, Heading, FormElement, GDateTime, LoadingSpan, BroadcastContainer };
    }
});
